export default "__VITE_ASSET__DxGRTewd__"